import { createContext } from "react"

import useCenterModal from "hooks/popup/useCenterModal"

import CenterModal from "components/modules/popup/CenterModal"

export const CenterModalStateContext = createContext([])

export const CenterModalCallbackContext = createContext({
  openCenterModal: () => {},
  closeCenterModal: () => {},
  ref: null,
})

const CenterModalProvider = ({ children }) => {
  const { openedCenterModals, openCenterModal, closeCenterModal, whiteboxRef } = useCenterModal()

  return (
    <CenterModalCallbackContext.Provider
      value={{ openCenterModal, closeCenterModal, ref: whiteboxRef }}
    >
      <CenterModalStateContext.Provider value={openedCenterModals}>
        {children}
        {openedCenterModals.map(({ id, Component, isBackground }) => (
          <CenterModal key={id} id={id} children={Component} isBackground={isBackground} />
        ))}
      </CenterModalStateContext.Provider>
    </CenterModalCallbackContext.Provider>
  )
}

export default CenterModalProvider
